import http from "../../services/http";
import { fieldActionTypes } from "./field.types";

export const setFields = (fields) => {
  return {
    type: fieldActionTypes.SET_FIELDS,
    payload: fields
  };
};

export const fetchFields = () => {
  return async (dispatch) => {
    try {
      const response = await http.get("/fields");
      dispatch(setFields(response.data));
    } catch (error) {
      console.error(error);
    }
  };
}

export const addField = (field) => {
  return async (dispatch) => {
    try {
      await http.post("/fields", field).then(response => console.log(response.data));
      dispatch(fetchFields());
    } catch (error) {
      console.error(error);
    }
  };
};

export const updateField = (field) => {
  return async (dispatch) => {
    try {
      await http.put(`/fields/${field.id}`, field);
      dispatch(fetchFields());
    } catch (error) {
      console.error(error);
    }
  };
};